<template>
  <div class="p-4">
    <button
      type="button"
      class="flex items-center gap-x-1 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      @click="onAnalyze"
    >
      <mdicon name="download-outline" class="h-5 w-5 mr-1" aria-hidden="true"></mdicon>
      Analyze
    </button>
    <div class="p-2">
      <input v-model="options.interface.appearance" type="radio" value="dark" /> dark <input v-model="options.interface.appearance" type="radio" value="light" /> light
      <InkMde class="font-jetbrains-mono text-sm" v-model="markdown" :options="options" />
    </div>
  </div>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import Button from 'primevue/button';
  import InkMde from 'ink-mde/vue';
  import { remark } from 'remark';

  const markdown = ref('# Hello, World!');
  const options = reactive({
    interface: {
      appearance: 'light',
      attribution: false,
      toolbar: true,
    },
  });

  function onAnalyze() {
    const processor = remark(); //unified().use(remarkParse);
    const syntaxTree = processor.parse(markdown.value);
    const a = 1;
    /*
    processor.process(markdown.value, (err, file) => {
      console.log(String(file));
    });*/
  }
</script>
